<template>
   <select-input
    v-model="formData"
    :label="label"
    :list="years"
    :required="required"
    :disabled="disabled"
    :show-select-disabled="showSelectDisabled"
    :no-form="noForm"
    @change="updated" />
</template>

<script>

import DateMixins from '@/mixins/DateMixins'

export default {
  name: 'select-year',

  mixins: [DateMixins],

  props: {
    value: {
      required: true
    },

    label: {
      type: String,
      default: 'Year'
    },

    required: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showSelectDisabled: {
      type: Boolean,
      default: true
    },

    back: {
      type: Number,
      default: 10
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    updated (value) {
      this.formData = Number(value)
      this.$emit('input', Number(value))
      this.$emit('change', Number(value))
    }
  },

  data () {
    return {
      formData: this.value,
      years: null
    }
  },

  created () {
    if (!this.years) {
      this.years = this.arrayOfYears(this.back)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectYear.vue?679475ac